import { render, staticRenderFns } from "./ResetAdminPasswordSidebar.vue?vue&type=template&id=004f55fc&scoped=true&"
import script from "./ResetAdminPasswordSidebar.vue?vue&type=script&lang=js&"
export * from "./ResetAdminPasswordSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ResetAdminPasswordSidebar.vue?vue&type=style&index=0&id=004f55fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f55fc",
  null
  
)

export default component.exports